export default {
    title: 'Partners',
    subtitle: 'The partners your ONISEP videos can credit. A partner is retired rather than deleted: the videos that already credit it keep it.',
    add: 'Add partner',
    addFirst: 'Add your first partner',
    addTitle: 'Add a partner',
    editTitle: 'Edit partner',
    edit: 'Edit',
    retire: 'Retire',
    restore: 'Restore',
    retired: 'Retired',
    retireTitle: 'Retire partner',
    retireMessage: 'Retire the partner "{name}"? It will no longer be offered for new videos. The videos that already credit it keep it, and you can restore it at any time.',
    internal: 'Internal',
    filters: {
        all: 'All partners',
        internal: 'Internal partners',
        external: 'External partners',
    },
    showRetired: 'Show retired partners',
    created: 'Partner added.',
    saved: 'Partner saved.',
    retiredToast: '"{name}" retired.',
    restored: '"{name}" restored.',
    search: 'Search partners...',
    empty: 'No partners yet.',
    noResults: 'No partners match your search.',
    refine: 'Only the first {count} partners are shown: refine your search.',
    table: {
        logo: 'Logo',
        name: 'Name',
        type: 'Type',
        url: 'URL',
        actions: 'Actions',
    },
    types: {
        institutional: 'Institutional',
        business: 'Business',
        media: 'Media',
    },
    form: {
        name: 'Partner name',
        type: 'Type',
        url: 'Website URL',
        urlHint: 'An address starting with http:// or https://',
        logo: 'Logo',
        logoHint: 'The logo shown with this partner, in ONISEP\'s catalogue too',
        isInternal: 'Internal partner',
    },
    errors: {
        load: 'The partners could not be loaded.',
        nameTaken: 'A partner already has this name — perhaps a retired one, which you can restore.',
        invalid: 'Check the name, the website (http:// or https://) and the logo — which must be uploaded again after a day.',
        forbidden: 'You are not allowed to manage partners.',
        unavailable: 'Partners are not available for this organization.',
        generic: 'The partner could not be saved.',
    },
}
